import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  busy: boolean;
}

const FilterWidgetBusyOverlay = ({ busy, children }: PropsWithChildren<Props>) => (
  <Box
    sx={{
      display: "flex",
      flex: 1,
      minHeight: 0,
      ...(busy && { pointerEvents: "none", opacity: 0.5 }),
    }}
  >
    {children}
  </Box>
);

export default FilterWidgetBusyOverlay;
